import { Action } from "@ngrx/store";
import { GlobalRoleDto } from "@admin_api/models/global-role-dto";

export enum ActionTypes {
    GetRoles = "[Roles] GetRoles",
    GetRolesSucceed = "[Roles] GetRolesSucceed",
    GetRolesFail = "[Roles] GetRolesFail"
}

export class GetRolesAction implements Action {

    constructor() {}

    readonly type = ActionTypes.GetRoles;
}

export class GetRolesSucceedAction implements Action {

    constructor(public roles: Array<GlobalRoleDto>) {}

    readonly type = ActionTypes.GetRolesSucceed;
}

export class GetRolesFailAction implements Action {

    constructor(public error: any) {}

    readonly type = ActionTypes.GetRolesFail;
}
